import { FILTER_SPLIT_KEY } from "@/constants";

export const combineFilter = (name: string, value: string) => {
	return `${name}${FILTER_SPLIT_KEY}${value}`;
};

export const splitFilter = (filter: string) => {
	const [field, value] = filter.split(FILTER_SPLIT_KEY);
	return {
		field,
		value,
	};
};
